import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { SelectedWorkSection } from './components/SelectedWorkSection';
import { PrivateProfileSection } from './components/PrivateProfileSection';
import { PortfolioSection } from './components/PortfolioSection';
import { PortfolioGate, PORTFOLIO_ACCESS_SESSION_KEY } from './components/PortfolioGate';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { MouseFollower } from './components/MouseFollower';
import './index.css';
export function App() {
  const [isPortfolioUnlocked, setIsPortfolioUnlocked] = useState(() => typeof window !== 'undefined' && window.sessionStorage.getItem(PORTFOLIO_ACCESS_SESSION_KEY) === 'granted');
  const [isPortfolioGateOpen, setIsPortfolioGateOpen] = useState(false);
  const handlePortfolioUnlock = () => {
    window.sessionStorage.setItem(PORTFOLIO_ACCESS_SESSION_KEY, 'granted');
    setIsPortfolioUnlocked(true);
    setIsPortfolioGateOpen(false);
    window.setTimeout(() => {
      document.getElementById('private-profile')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 150);
  };
  return <>
      <main className="min-h-screen w-full bg-dark" data-id="element-0">
        <MouseFollower data-id="element-1" />
        <Navbar isPortfolioUnlocked={isPortfolioUnlocked} onRequestPortfolioAccess={() => setIsPortfolioGateOpen(true)} data-id="element-2" />
        <HeroSection isPortfolioUnlocked={isPortfolioUnlocked} onRequestPortfolioAccess={() => setIsPortfolioGateOpen(true)} data-id="element-3" />
        <AboutSection data-id="element-4" />
        <ServicesSection data-id="element-5" />
        <SelectedWorkSection data-id="element-6" />
        {isPortfolioUnlocked && <>
            <PrivateProfileSection data-id="element-7" />
            <PortfolioSection data-id="element-8" />
          </>}
        <TestimonialsSection data-id="element-9" />
        <ContactSection data-id="element-10" />
        <Footer data-id="element-11" />
      </main>

      <PortfolioGate isOpen={isPortfolioGateOpen} onClose={() => setIsPortfolioGateOpen(false)} onUnlocked={handlePortfolioUnlock} data-id="element-12" />
    </>;
}